import React from "react";
import { Link } from "react-router-dom";
import { Boxes } from "lucide-react";

export const Brand = ({ to = "/", light = false, className = "" }) => (
  <Link to={to} className={`inline-flex items-center gap-2 group ${className}`} data-testid="brand-logo">
    <span className={`grid place-items-center h-8 w-8 ${light ? "bg-white text-primary" : "bg-primary text-primary-foreground"}`}>
      <Boxes className="h-5 w-5" strokeWidth={2.25} />
    </span>
    <span className={`text-lg font-bold tracking-tight ${light ? "text-white" : "text-foreground"}`}>
      Onboard<span className="text-accent">HQ</span>
    </span>
  </Link>
);

export default Brand;
